import type { GenericError, RequestStatus } from '@skynet/data-ws-core';
import type { JsonExchange } from '@skynet/data-shared-exchanges';
import type { JsonArbitrageAccount } from '@skynet/data-arbitrage';

export enum ArbitrageInfoCommands {
  GetArbitrage = 'GetArbitrage',
  ArbitrageInfo = 'ArbitrageInfo',
}

export interface GetArbitrageDataWsPayload {
  projectID?: number;
  loanID?: number;
}

export interface ArbitrageInfoTotal {
  id: number;
  pair: string;
  match: string;
  accountsTotal: number;
  accountsActive: number;
  spread: number;
  buyPrice: number;
  sellPrice: number;
  volume24: number;
  volume: number;
  disbalance: number;
  profit: number;
  status: string;
}

export interface ArbitrageInfoData extends JsonArbitrageAccount {
  exchange: JsonExchange | undefined;
}

export interface JsonArbitrageInfo {
  total: ArbitrageInfoTotal;
  accounts: JsonArbitrageAccount[];
  command: ArbitrageInfoCommands.ArbitrageInfo;
}

export interface ArbitrageInfoState {
  total: ArbitrageInfoTotal | null;
  accounts: JsonArbitrageAccount[];
  error: GenericError | null;
  status: RequestStatus;
  /**
   * Project/loan the open `Listen` subscription was sent for, or `null` while
   * none is open for the selected entity. The `ArbitrageInfo` push carries no
   * id of its own, so this is the only way to tell a response for the current
   * entity from one still arriving for the previous subscription.
   */
  subscribedId: number | null;
}
